
import {
    Box,
    Typography,
    useTheme,
    useMediaQuery,
    IconButton,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    List,
    ListItem,
    ListItemText
} from "@mui/material";
import { useState } from "react";
import {
    Close,
    Menu,
    Notifications,
} from "@mui/icons-material";
import FlexBetween from "../../components/FlexBetween";

import { useNavigate } from "react-router-dom";
import NavOptions from "./NavOptions";

const notices = [
    { title: '🔥 Major Release', message: 'Uben is now available to the public. Sign up now to get started!' },
    { title: '📚 KAnki Integration', message: 'You can now import Anki decks (.apkg) into Uben, edit them, and export as kanki_config.js for your Kindle!' },
    { title: '👥 Community Page', message: 'New community page available! Search for other users, follow them, and view their stats.' },
];

const Navigation = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [isMobileMenuToggled, setIsMobileMenuToggled] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false); // State for dialog

    const isNonMobileScreens = useMediaQuery("(min-width: 900px)");

    const background = theme.palette.background.default;

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Box
            width="100%"
            p="1rem 6%"
            textAlign="center"
        >
            <FlexBetween gap="1.75rem">
                <Typography
                    fontWeight="bold"
                    fontSize="clamp(1rem, 2rem, 2.25rem)"
                    // onClick={() => navigate("/home")}
                    sx={{
                        color: "white",
                        // cursor: "pointer",
                        cursor: "default",
                    }}
                >
                    Uben
                </Typography>

                {/* <NavOptions />  */}
                {isNonMobileScreens ? (
                    <NavOptions />
                ) : (
                    null
                )}

                {/* Email Input Dialog */}
                <Dialog open={dialogOpen} onClose={handleDialogClose} aria-labelledby="dialog-title" sx={{
                    "& .MuiDialog-paper": {
                        position: 'fixed',
                        right: 0,
                        top: 0,
                        height: '100vh',
                        width: { xs: '80%', sm: '50%', lg: '20%' },
                        overflowY: 'hidden',
                        overflowX: 'hidden',
                    }
                }}>
                    <DialogTitle id="dialog-title">Latest Notices and Updates</DialogTitle>
                    <DialogContent>
                        <List>
                            {notices.length > 0 ? (
                                notices.map((notice, index) => (
                                    <ListItem key={index} button onClick={() => {
                                        if (notice.message.includes('updates')) {
                                            navigate('/updates');
                                        }
                                    }
                                    }>
                                        <ListItemText primary={notice.title} secondary={notice.message} />
                                    </ListItem>
                                ))
                            ) : (
                                <DialogContentText>No new notices at the moment.</DialogContentText>
                            )}
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose} sx={{
                            color: theme.palette.text.primary,
                            borderColor: theme.palette.text.primary,
                            "&:hover": {
                                borderColor: theme.palette.text.primary,
                                color: theme.palette.text.dark,
                                backgroundColor: theme.palette.text.primary,
                            },
                        }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                {isNonMobileScreens ? (
                    <FlexBetween gap="2rem">
                        <Box
                            display="flex"
                            gap="1rem"
                            justifyContent={isNonMobileScreens ? "flex-start" : "center"}
                        >
                            <Button variant="outlined" onClick={() => navigate("/login")}
                                sx={{
                                    color: "white",
                                    borderColor: "black",
                                    fontSize: "1rem",
                                    borderRadius: "10px",

                                    "&:hover": {
                                        backgroundColor: "black",
                                        color: "white",
                                        borderColor: "black",
                                        transform: "translateY(-1px)",
                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.4)",
                                    },
                                    transition: "all 0.2s ease-in-out"
                                }}
                            >
                                Login
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => window.open("https://discord.gg/JtcrpG7ECA", "_blank")}
                                sx={{
                                    backgroundColor: "#5865F2",
                                    color: "white",
                                    fontSize: "1rem",
                                    borderRadius: "10px",
                                    "&:hover": {
                                        backgroundColor: "#4752C4",
                                        transform: "translateY(-1px)",
                                        boxShadow: "0 2px 8px rgba(88, 101, 242, 0.4)",
                                    },
                                    transition: "all 0.2s ease-in-out"
                                }}
                            >
                                Join Discord
                            </Button>
                            <IconButton onClick={handleDialogOpen} sx={{ color: "black" }}>
                                <Notifications />
                            </IconButton>
                        </Box>
                    </FlexBetween>
                ) : (
                    <Box
                        display="flex"
                        gap="1rem"
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        <IconButton onClick={handleDialogOpen} sx={{ color: "black" }}>
                            <Notifications />
                        </IconButton>
                        <IconButton
                            onClick={() => setIsMobileMenuToggled(!isMobileMenuToggled)}
                            sx={{ color: "black" }}
                        >
                            <Menu />
                        </IconButton>
                    </Box>
                )}
                {!isNonMobileScreens && isMobileMenuToggled && (
                    <Box
                        position="fixed"
                        right="0"
                        bottom="0"
                        height="100%"
                        zIndex="10"
                        maxWidth="500px"
                        minWidth="300px"
                        sx={{
                            backgroundImage: "linear-gradient( 0deg,  rgb(122, 177, 248) 6.5%, rgba(86,118,191,1) 100% )"
                        }}
                    >
                        {/* CLOSE ICON */}
                        <Box display="flex" justifyContent="flex-end" p="1rem">
                            <IconButton onClick={() => setIsMobileMenuToggled(!isMobileMenuToggled)}>
                                <Close />
                            </IconButton>
                        </Box>

                        {/* MENU CONTENT */}
                        <Box
                            display="flex"
                            flexDirection="column"
                            height="100%"
                            sx={{ overflowY: "auto" }}
                        >
                            {/* Get Started Button - Fixed at top */}
                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                gap="1rem"
                                p="1rem"
                                borderBottom="1px solid #E0E0E0"
                                sx={{ flexShrink: 0 }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={() => navigate("/login")}
                                    sx={{
                                        width: "100%",
                                        fontSize: "1.1rem",
                                        fontWeight: "600",
                                        py: 1.5,
                                        borderRadius: "8px",
                                        textTransform: "none",
                                        backgroundColor: 'rgba(122, 177, 248, 0.9)', // Same blue as NavOptions
                                        color: "white",
                                        border: '1px solid rgba(86,118,191,1)',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                        "&:hover": {
                                            backgroundColor: 'rgba(86,118,191,1)', // Darker blue on hover
                                            transform: 'translateY(-1px)',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                        },
                                        transition: "all 0.2s ease-in-out"
                                    }}
                                >
                                    Login
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => window.open("https://discord.gg/JtcrpG7ECA", "_blank")}
                                    sx={{
                                        width: "100%",
                                        fontSize: "1.1rem",
                                        fontWeight: "600",
                                        py: 1.5,
                                        borderRadius: "8px",
                                        textTransform: "none",
                                        backgroundColor: "#5865F2",
                                        color: "white",
                                        "&:hover": {
                                            backgroundColor: "#4752C4",
                                            transform: "translateY(-1px)",
                                            boxShadow: "0 2px 8px rgba(88, 101, 242, 0.4)",
                                        },
                                        transition: "all 0.2s ease-in-out"
                                    }}
                                >
                                    Join Discord
                                </Button>
                            </Box>

                            {/* NavOptions in Mobile Menu - Scrollable */}
                            <Box
                                flex="1"
                                p="1rem"
                                sx={{
                                    overflowY: "auto",
                                    minHeight: 0 // Important for flex scrolling
                                }}
                            >
                                <NavOptions isMobile={true} />
                            </Box>
                        </Box>
                    </Box>
                )}

            </FlexBetween>
            {/* Removed NavOptions for mobile - cleaner UI */}
        </Box>
    );
};

export default Navigation;
